const context = require.context('./', false, /\.svg$/)

const icons = context.keys().reduce((acc, key) => {
  const clean = key.replace('./', '').replace('.svg', '')
  const isFull = clean.endsWith('-full')
  const name = isFull ? clean.replace('-full', '') : clean

  if (!acc[name]) acc[name] = {}
  acc[name][isFull ? 'full' : 'normal'] = context(key)

  return acc
}, {})

export default icons
